export const SET_TEMPERATURE = 'SET_TEMPERATURE';
export const GET_WEATHER_FOR_ZIPCODE = 'GET_WEATHER_FOR_ZIPCODE';

export function setTemperature(temperature) {
    return { type: SET_TEMPERATURE, temperature };
}

export function getWeatherForZipcode(zipcode) {
    return { type: GET_WEATHER_FOR_ZIPCODE, zipcode };
}